import { useEffect, useRef } from 'react'
import { ui, UUID } from '@beelday/common'
import { Answer, PollingListQuestion } from './list-polling-models'
import { useProfileFor } from 'users/redux'
import ProfileAvatar from 'users/profile-avatar'
import { useAssertedWorkflowUser } from 'room/common/use-workflow-user'
import { getDisplayName } from '@beelday/common/src/user-api'
import { ListAnswerField } from './list-answer-field'

type Props = {
	answers?: Answer[]
	question: PollingListQuestion
	isTrainer: boolean
	letFacilitatorAnswer: boolean
	allowForMultipleAnswer: boolean
	onSubmit: (questionId: UUID, text: string) => unknown
}

const ListPollingChat = ({
	question,
	answers,
	isTrainer,
	letFacilitatorAnswer,
	allowForMultipleAnswer,
	onSubmit,
}: Props): JSX.Element | null => {
	const containerRef = useRef<ui.ListPollingContainerRef>(null)
	const currentUser = useAssertedWorkflowUser()

	const userAnswered = !!answers?.find(
		answer => answer.userId === currentUser.id
	)

	useEffect(() => {
		if (containerRef.current) {
			containerRef.current.scrollToBottom()
		}
	}, [answers])

	return (
		<ui.ListPollingChatContainer>
			<ui.ListPollingHeader>{question.text}</ui.ListPollingHeader>
			<ui.ListPollingScrollContainer ref={containerRef}>
				{answers
					? answers?.map((answer, index) => (
							<SingleAnswer key={`${answer.userId}_${index}`} answer={answer} />
					  ))
					: null}
			</ui.ListPollingScrollContainer>

			{isTrainer && !letFacilitatorAnswer ? null : (
				<ListAnswerField
					questionId={question.id}
					answerGiven={!allowForMultipleAnswer && userAnswered}
					onSubmit={onSubmit}
				/>
			)}
		</ui.ListPollingChatContainer>
	)
}

const SingleAnswer = ({ answer }: { answer: Answer }): JSX.Element | null => {
	const profile = useProfileFor(answer.userId)
	return (
		<ui.ListPollingAnswer
			name={getDisplayName(profile)}
			text={answer.text}
			avatar={<ProfileAvatar profile={profile} />}
		/>
	)
}

export default ListPollingChat
